// extracted by mini-css-extract-plugin
module.exports = {"itemDragHandle":"GVItemsCustomOrder_itemDragHandle__8r24x","itemDragged":"GVItemsCustomOrder_itemDragged___qjYe","hidden":"GVItemsCustomOrder_hidden__ACduN"};